import { useMutation } from '@apollo/client/react'
import { Button, Typography } from '@faceup/ui-base'
import { graphql } from '../__generated__'

const { Paragraph } = Typography

type PaymentLinkProps = {
  motherId: string
  isOfflinePayment?: boolean
}

const mutations = {
  createPaymentUrlMutation: graphql(`
    mutation CreatePaymentUrlMutation($input: CreatePaymentUrlInput!) {
      createPaymentUrl(input: $input) {
        url
      }
    }
  `),
}

export const PaymentLink = ({ motherId, isOfflinePayment }: PaymentLinkProps) => {
  const [createPaymentUrl, { loading, data }] = useMutation(mutations.createPaymentUrlMutation, {
    variables: { input: { motherId, allowOfflinePaymentMethods: Boolean(isOfflinePayment) } },
  })

  const paymentUrl = data?.createPaymentUrl?.url

  return (
    <>
      <Button
        ghost
        type='primary'
        onClick={() => createPaymentUrl()}
        loading={loading}
        disabled={Boolean(paymentUrl)}
      >
        Payment URL {isOfflinePayment ? '💳 & 🏦' : '💳'}
      </Button>
      {paymentUrl && <Paragraph copyable>{paymentUrl}</Paragraph>}
    </>
  )
}
